import { Button, Popconfirm } from "antd";
import React from "react";
import { Link } from "react-router-dom";
import { QuestionCircleOutlined } from "@ant-design/icons";
import axios from "axios";

function LocationTable({ data, getLocationData, initialVlue, handleChange, reset }) {
  const handleLocationDelete = async (id) => {
    try {
      const delet = await axios.delete(
        `https://abarishr.hennainternational.in/api/location/delete/${id}`
      );
      getLocationData(1);
    } catch (error) { }
  };
  return (
    <div className="pageTable">
      <div className="tableLength d-flex form-search">
        <div className="dataTables_length">
          <input
            type="text"
            className="form-control"
            name="search"
            id="language_level"
            autoComplete="off"
            placeholder="search..."
            style={{ width: '600px' }}
            value={initialVlue?.search}
            onChange={handleChange}
          />
        </div>
        <div className="dataTables_length">
          <button type="button" className="btn btn-primary me-2" onClick={() => getLocationData(1)}>Search</button>
          <button type="button" className="btn btn-primary" onClick={() => reset(1)}>reset</button>
        </div>
      </div>
      <table className="table table-striped table-bordered ">
        <thead>
          <tr role="row" className="heading">
            <th>S.No</th>

            <th>Location / City Code</th>
            <th>Location / City Name</th>
            <th>Status</th>
            <th>Actions</th>
          </tr>
        </thead>
        <tbody>
          {data &&
            data?.data?.map((item, i) => {
              console.log(item);
              return (
                <tr role="row" className="odd" key={i}>
                  <td className="sorting_1">{i + 1}</td>
                  <td>
                    <span>{item.location_code}</span>
                  </td>
                  <td>{item.location_name}</td>
                  <td>
                    {console.log(item?.is_active)}
                    <span>{item?.is_active === 0 ? "Inactive" : "Active"}</span>
                  </td>
                  <td>

                    <div className="dropdown">
                      <button
                        className="btn btn-primary dropdown-toggle"
                        type="button"
                        id="dropdownMenuButton1"
                        data-bs-toggle="dropdown"
                        aria-expanded="false"
                      >
                        Action
                      </button>
                      <ul className="dropdown-menu">
                        <li>
                          <Link
                            className="dropdown-item"
                            to={`/admin/edit-location/${item._id}`}
                          >
                            Edit
                          </Link>
                        </li>
                        <li>
                          <Popconfirm
                            title="Delete the task"
                            description="Are you sure to delete this Location?"
                            onConfirm={() => handleLocationDelete(item?._id)}
                            icon={
                              <QuestionCircleOutlined
                                style={{
                                  color: "red",
                                }}
                              />
                            }
                          >
                            <Button danger>Delete</Button>
                          </Popconfirm>
                        </li>
                        {/* <li>
                          <a className="dropdown-item" href="#">
                            Mark in Active
                          </a>
                        </li> */}
                      </ul>
                    </div>
                  </td>
                </tr>
              );
            })}
        </tbody>
      </table>
    </div>
  );
}

export default LocationTable;
